import React from 'react';
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { useNavigate } from 'react-router-dom';

interface BoardListProps {
  boards: Array<{
    id: string;
    name: string;
  }>;
  onRename: (type: 'organization' | 'workspace' | 'board', id: string, name: string) => void;
  onDelete: (type: 'organization' | 'workspace' | 'board', id: string, name: string) => void;
}

export const BoardList: React.FC<BoardListProps> = ({
  boards,
  onRename,
  onDelete,
}) => {
  const navigate = useNavigate();

  const handleBoardClick = (boardId: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    navigate(`/board/${boardId}`);
  };

  return (
    <div className="space-y-2">
      {boards?.map((board) => (
        <div key={board.id} className="flex items-center justify-between border-l-2 pl-4">
          <button
            onClick={(e) => handleBoardClick(board.id, e)}
            className="flex items-center gap-2 w-full px-2 py-1.5 text-sm rounded-sm hover:bg-accent text-left"
          >
            {board.name}
          </button>
          <div className="flex gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onRename('board', board.id, board.name)}
            >
              <Pencil className="h-4 w-4" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onDelete('board', board.id, board.name)}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};